import { render, staticRenderFns } from "./ClientDetailAdmin.vue?vue&type=template&id=18ba0a37&scoped=true&"
import script from "./ClientDetailAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientDetailAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailAdmin.vue?vue&type=style&index=0&id=18ba0a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba0a37",
  null
  
)

export default component.exports